import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const onespace = "\xA0";
const useStyles = makeStyles((theme) => ({
  text: {
    pointerEvents: "none",
    userSelect: "none",
    fontSize: "10px",
    fill: theme.palette.text.secondary
  }
}));
const RadarFooter = (props) => {
  const { x, y, spaces = 5, labels } = props;
  const classes = useStyles(props);
  const space = onespace.repeat(spaces);
  return /* @__PURE__ */ React.createElement(
    "text",
    {
      "data-testid": "radar-footer",
      transform: `translate(${x}, ${y})`,
      className: classes.text
    },
    `\u25B2 moved up${space}\u25BC moved down`,
    labels && space,
    labels?.join(space)
  );
};

export { RadarFooter as default };
//# sourceMappingURL=RadarFooter.esm.js.map
